import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import './TerminatedVPOpportunities.css';
import Select from 'react-select';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import accounting from 'accounting-js';
import ReactExport from "react-export-excel";
import { Checkbox, TextArea } from 'semantic-ui-react'
import {
    getVendortvOpportunityByCategoryData, getVendorOpportunityByMemberData, getMemberVendorNames,
    getVendorTop10CategoriesData, getProductCategorycorporate, getVendorTop10MembersData
    , getTerminatedVPNames, getProductDetail, saveProductFeedback,
    getVendorConverisonMonthsFilter,tabTracking
} from '../../../actions';
import Filters from '../../../components/Filters';
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import { Link } from 'react-router-dom';
import { Card, Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import _cloneDeep from 'lodash/cloneDeep';
import { Dropdown } from 'semantic-ui-react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { PriceFormatter, dynamicDateFilters1, PercentFormatter, monthName, monthName1, paramsToJSON, paramsToJSON1, jsonToParam } from '../../../helper';
import { matLoader } from '../../../components/Loader';

class TVPOpportunities extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedFilterPeriod: "YTD",
            buttonOptionsPeriod: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval:[],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
            isLoading: true,
            params: {
                period: "YTD",
                ytd: "true",
                qtr: "false",
                mth: "false",
                year: 2022,
                month: 12,
                quarter: 1,
                // buyingGroupId: 0,
                // isCompliant: "A",
                terminatedVendorId: '441',
                productGroupId :'',
                //tier4Id: '',
                memberId: "",
                vendorId: this.props.vendorIdForCorporate,
                dropDown: []
            },
            selectedVendorPartner: '',
            vendorPartnerDropdownArr: [],
            filteredOpportunityByCategory: [],
            filteredOpportunityByMember: [],
            showProductListModal: false,
            showPopUpForProductFedbackDetails: false,
            disableNewProductCategoryDropdown: true,
            showProductListModalPopUp: false,
            expanded: false,

            dataForChart1: {
                legend: {
                    position: 'inset',
                    show: false,
                    inset: {
                        anchor: 'top-left',
                        x: 20,
                        y: -40,
                        step: 1
                    }
                },
                padding: {
                    bottom: 100,
                },
                data: {
                    columns: [],
                    type: 'bar',
                    colors: {
                        data1: '#ff0000'
                    },
                    names: {
                        data1: "Member Purchase",
                    }


                },
                bar: {
                    width: {
                        ratio: 0.5 // this makes bar width 50% of length between ticks
                    },
                    // or
                    //width: 100 // this makes bar width 100px
                }, axis: {
                    x: {
                        label: "Member ID",
                        type: 'category', // this needed to load string x value,
                        tick: {
                            rotate: -20,
                            multiline: false
                        },
                        height: 80
                    },
                    y: {
                        label: "Purchase Amount",
                        //type: 'Purchase Amount',
                        tick: {
                            format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                            //                format: function (d) { return "$" + d; }
                        }
                    }
                }

            },
            chartTitle2: {
                show: false,
                text: 'Top 10 Categories',
            },
            dataForChart2: {
                data: {
                    columns: [],
                    type: 'bar',
                    colors: {
                        data1: '#ff0000'
                    },
                    names: {
                        data2: "Member Purchase",
                    }
                },
                bar: {
                    width: {
                        ratio: 0.5 // this makes bar width 50% of length between ticks
                    }
                    // or
                    //width: 100 // this makes bar width 100px
                }, axis: {
                    // x: {
                    //     label:"Purchase Amount",
                    //     type: 'Category ID',
                    //     tick: {
                    //         rotate: -20,
                    //         multiline: false
                    //     }
                    //     ,
                    //     height:80 // this needed to load string x value
                    // },
                    x: {
                        tick: {
                            values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
                        },
                        label: "Rank",
                        type: 'category' // this is needed to load string x value
                    },
                    y: {
                        type: 'Purchase Amount',
                        tick: {
                            format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                            //                format: function (d) { return "$" + d; }
                        }
                    }
                }
            },
            expanded: false,
            refreshData: true,

        }
        this.filteredOpportunityByMemberArr = [];
        this.filteredOpportunityByCategoryArr = [];
    }
    handleUserSelectedFilter(option) {
        let obj = {};
         
        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }
       
    let paramsValues = this.state.params;
    let paramsfinal = paramsToJSON1(paramsValues);
    let month = paramsfinal.month;
    if(month >= 1 && month <= 3){
        paramsfinal.quarter= 1
    }
    else if(month >= 4 && month <= 6){
        paramsfinal.quarter = 2
    }
    else if(month >= 7 && month <= 9){
        paramsfinal.quarter = 3
    }
    else if(month >= 10 && month <= 12){
        paramsfinal.quarter = 4
    }
    
    let params = jsonToParam(paramsfinal);
        this.setState({ selectedFilterPeriod: option,params: params}, () => {
            this.setFilter({ period: this.state.selectedFilterPeriod, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });

    }
    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
                let obj = {};
                obj[event.name] = event.value;
                params.quarter = event.value;
                let quarter = params.quarter
                params = jsonToParam(params);
                this.setState({
                    quarter:quarter,
                    params: params})
                this.setState(obj, () => {
                    this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
                });
        
            }
    handleChangeOfDropdownMonth = (e) => {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month=params.month
        let selectedItem =  {label: monthName1(month), value: month}
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,
            
        })
        this.props.getVendortvOpportunityByCategoryDataAPI(params)
        this.props.getVendorTop10CategoriesDataAPI(params)
        this.props.getVendorTop10MembersDataAPI(params)
        this.props.getVendorOpportunityByMemberDataAPI(params)
        this.props.getProductCategorycorporateAPI(params)
          }
          handleChangeOfDropdownYear(e) {
           
            let params = this.state.params;
            params = paramsToJSON1(params);
            let year = ''
                let items =[]
                params.year = e.value
                year = params.year
                let selectedYear=  {label: year , value :year}
                let dataval = Object.keys(this.props.getVendorConverisonMonthsFilter);
                let yearval = dataval.map((val) => {
                    return {
                        label: val,
                        value: val,
                    }
                })
        
                let selectedYear1 = yearval[yearval.length - 1];
                // if (selectedYear1.value != 2023 && e.value == 2023 )
                    if (selectedYear1.value != 2024 && e.value == 2024 )
                {
                    items = [{ label: monthName1(1),value: 1}];
                }
                else {
                let dataval1 = Object.values(this.props.getVendorConverisonMonthsFilter[year]);
                if(typeof dataval1 == 'undefined')
                    {
                      items = [{ label: monthName1(1),value: 1}];
                  
                    }
                    else{
                      items = dataval1.map(itemval => {
                          return {
                              label: monthName1(itemval),
                              value: itemval,
                          }
              
                      })
                  }
                }
                
                let selectedItem = items[items.length - 1];
                params.month = selectedItem.value;
                let month = selectedItem.value;
                if (month >= 1 && month <= 3) {
                    params.quarter = 1
                }
                else if (month >= 4 && month <= 6) {
                    params.quarter = 2
                }
                else if (month >= 7 && month <= 9) {
                    params.quarter = 3
                }
                else if (month >= 10 && month <= 12) {
                    params.quarter = 4
                }
                params = jsonToParam(params);
                this.setState({
                    params: params,
                    selectedYear: selectedYear,
                    items: items,
                    selectedItem : selectedItem,
            })
            this.setState(e, () => {
                this.setFilter({ year: this.state.year, selectedYear: selectedYear,selectedItem:selectedItem });
            });
        
    
        }
        getOptionsYear(){
            let dataval = Object.keys(this.props.getVendorConverisonMonthsFilter);
            let yearval = dataval.map((val) =>
                {
                    return {
                        label: val,
                        value: val,
                    }
            })
            let selectedYear=  yearval[yearval.length - 1];
             // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
            if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
        else if (selectedYear.value != 2023 && selectedYear.value != 2024){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });

        }
         //add this new code
         else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
            // params = jsonToParam(params);
            this.setState({
                selectedYear:selectedYear,
                yearval:yearval,
                // params: params ,
            })
        }
    
    getOptions(){
        let params = this.state.params;
        params = paramsToJSON(params);
        let items =[]
        let dataval = Object.keys(this.props.getVendorConverisonMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];
        params.year = selectedYear1.value;

        let dataval1 = Object.values(this.props.getVendorConverisonMonthsFilter[selectedYear1.value]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }

        if (selectedYear1.value != 2022)
        {
        yearval.push({ label: 2022, value: 2022 });
        }

        
        let selectedItem=  items[items.length - 1];
        params.month = selectedItem.value ; 
        
        let month = selectedItem.value;
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params ,
        })
        this.props.getMemberVendorNamesAPI(params)
        this.props.getVendortvOpportunityByCategoryDataAPI(params)
        this.props.getVendorTop10CategoriesDataAPI(params)
        this.props.getVendorTop10MembersDataAPI(params)
        this.props.getVendorOpportunityByMemberDataAPI(params)
        this.props.getProductCategorycorporateAPI(params)
}
    
    
renderButtonGroup() {

    return this.state.buttonOptionsPeriod.map((option, index) => {
        return (
            <button  style ={{height:'38px'}} key={index} type="button" value={option}
                onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                class={`btn btn-light ${(this.state.selectedFilterPeriod === option) ? "active" : null}`}>{option}</button>
        )
    })
}
    // handleChangeOfDropdown(event) {
    //     let obj = {};
    //     obj[event.name] = event.value;
    //     this.setState(obj, () => {

    //         //params= paramsToJSON(params);
    //         this.setFilter({ buyingGroupId: this.state.buyingGroupId, isCompliant: this.state.isCompliant });
    //         //params= jsonToParam(params);
    //     });
    // }
    setFilter = (filter) => {
        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {
            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            params.period = filter.period;

        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }

        params = jsonToParam(params);
        this.setState({

            params: params,
            refreshData: true,
            isLoading: true,

        }, () => Promise.all([
            this.props.getVendortvOpportunityByCategoryDataAPI(params),
            this.props.getVendorTop10CategoriesDataAPI(params),
            this.props.getVendorTop10MembersDataAPI(params),
            this.props.getVendorOpportunityByMemberDataAPI(params),
            this.props.getProductCategorycorporateAPI(params),
            this.props.getMemberVendorNamesAPI(params)
        ]).then(data => {

            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))

    }
 

    componentWillMount() {

        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });

    }

    componentDidMount() {
        
        console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptions: ["YTD", "QTR"], selectedFilter: "YTD" });
        }
        Promise.all([
            this.props.getVendorConverisonMonthsFilterAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=10"),
        ]).then(data => {
            this.getOptions();

            this.getOptionsYear();
            
            this.setState({
                isLoading: false
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
           // window.location.reload();

        })
        let checkStorage = localStorage.setItem('flag','11')
        setTimeout(function () { localStorage.removeItem("flag"); }, 5000);

    }

    renderVendorPartners() {
        return this.state.vendorPartnerDropdownArr.map((vendor, index) => {
            return (
                <option key={index} value={vendor}>{vendor}</option>
            )
        })
    }



    componentWillReceiveProps(props) {

        const { refreshData, selectedVendorPartner } = this.state;
        const { opportunityByMember } = props;
        console.log('inside --- ', selectedVendorPartner);
        let vendorPartnerDropdownArr = new Set();

        !_isEmpty(opportunityByMember) && opportunityByMember.map((opportunity) => {

            vendorPartnerDropdownArr.add(opportunity.terminatedVendorPartner);
        });
        vendorPartnerDropdownArr = Array.from(vendorPartnerDropdownArr);

        if (!_isEqual(this.state.vendorPartnerDropdownArr, vendorPartnerDropdownArr)) {
            this.setState({ vendorPartnerDropdownArr: vendorPartnerDropdownArr, selectedVendorPartner: vendorPartnerDropdownArr[0] });
        }





    }
    handleChange = (e, { value }) => {
        // this.setState({ value })
        let params = this.state.params;
        params = paramsToJSON(params);
        params.terminatedVendorId = value;
        params = jsonToParam(params);
        this.setState({ params: params, })
        this.props.getVendortvOpportunityByCategoryDataAPI(params);
        this.props.getVendorTop10CategoriesDataAPI(params);
        this.props.getVendorTop10MembersDataAPI(params);
        this.props.getVendorOpportunityByMemberDataAPI(params);
    }

    renderPaginationShowsTotal(start, to, total) {
        return (
            <p style={{ color: '' }}>
                Showing rows { start} to { to}
            </p>
        );
    }
    // handleClick = (e, value) => {
    //     let params = this.state.params;
    //     params = paramsToJSON(params);
    //     params.dropDown = [{ "terminatedVendorId": [e.target.value] }]

    //     params = jsonToParam(params);
    //     this.props.getVendortvOpportunityByCategoryDataAPI(this.state.params);
    //     this.props.getVendorTop10CategoriesDataAPI(this.state.params);
    //     this.props.getVendorTop10MembersDataAPI(this.state.params);
    //     this.props.getVendorOpportunityByMemberDataAPI(this.state.params);
    // }

    showPopUp = (cell, row) => <div><i class="fas fa-external-link-alt"></i></div>;

    showProductListIcon = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">Details for {row.tier4}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showProductListModal(row)
                }}> <i className="fa fa-info-circle"></i></Link>
            </OverlayTrigger>
        )
    }
    showProductListModal = (row) => {

        this.setState({ selectedproductGroupId: row.tier4Id, productName: row.tier4, showProductListModal: true, showProductListModalPopUp: true }, () => {

            let selections = this.state.params;
            selections = paramsToJSON(selections);
            selections.tier4Id = this.state.selectedproductGroupId;
            selections.productGroupId = this.state.selectedproductGroupId;

            selections = jsonToParam(selections);
            console.log(selections);
            // this.props.getVendortvOpportunityByCategoryDataAPI(selections, (res) => {
            this.props.getProductDetailAPI(selections, (res) => {
                toast(res.data.message);
            });
            // this.setState({ showProductListModal: false});
        });
    }
    closeProductListModal = () => {
        this.setState({ showProductListModal: false, showProductListModalPopUp: false });
    }

    showProductFeedbackIcon = (cell, row) => {
        //;
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">Feedback for {row.outVendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showProductFeedbackModal(row)
                }}> < i className="fas fa-comment-alt"></i></Link>
            </OverlayTrigger>
        )
    }
    showProductFeedbackModal = (row) => {
        this.setState({
            productId: row.productId, productDesc: row.productDesc,
            showProductFeedbackModal: true, showPopUpForProductFedbackDetails: true
        });

    }
    closeProductFeedbackModal = () => {
        this.setState({ showPopUpForProductFedbackDetails: false, showProductFeedbackModal: false,disableNewProductCategoryDropdown:true,
            textareaValue: '',  showProductFeedbackModal: false,suggestedCategoryName:'', selectCategoryErrorMessage: ''  });
    }
    handleOnChange(event) {
        this.setState({
            textareaValue: event.target.value
        })
        this.refs.comment.value = '';
    }
    handleCategoryClick = (e, value) => {
        let arr = [];
        let arr1 = [];
        let valuestr = [value.value];
        if (valuestr > 0) {
            let valueee = valuestr.map((option, index) => {
                let val = _find(value.options, ['value', option])
                arr.push(val.value)
                arr1.push(val.text)
            })


        }
        this.setState({ suggestedCategoryId: encodeURIComponent(arr), suggestedCategoryName: encodeURIComponent(arr1), selectCategoryErrorMessage: '' })

    }
    sendProductFeedback() {
          ;
        let selections = {
            productId: this.state.productId,
            productDesc: this.state.productDesc,
            categoryId: this.state.selectedproductGroupId,
            categoryName: this.state.productName,
            feedbackComment: this.state.textareaValue,
            productCategoryWrong: this.state.feedbackToggleForWrongClassification,
            suggestedCategoryId: this.state.suggestedCategoryId,
            suggestedCategoryName: this.state.suggestedCategoryName,
        }

        if (!this.state.suggestedCategoryName) {
            this.setState({ selectCategoryErrorMessage: 'Please select a Category' }, () => {
            });
        } else {
            this.setState({ showPopUpForProductFedbackDetails: false,disableNewProductCategoryDropdown:true, textareaValue: '',  showProductFeedbackModal: false, selectCategoryErrorMessage: '',suggestedCategoryName:"" }, () => {
                this.props.saveProductFeedbackAPI(selections, (res) => {
                    toast(res.data.text);

                });

            });
        }
    }

    renderOpportunityByMember() {
        return (
            <div className="" >
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        <div className="card-body" style={{ maxHeight: " 303" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}>Opportunity by Member</h5>

                            <BootstrapTable search height='298' data={this.props.opportunityByMember} striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} width='104px' dataSort={true} isKey dataField='memberId'>Member Id </TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} width='142px' dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} width='148px' dataFormat={PriceFormatter} dataSort={true} dataField='opportunity'>Member Purchase</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} width='140px' dataSort={true} dataField='terminatedVendorName'>Leaving Supplier</TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderOpportunityByProductGroup() {
        return (
            <div className="">
                <div className="card-deck">
                    <div className="card shadow-sm mb-3">
                        <div className="card-body" style={{ maxHeight: " 305" }}>
                            <h5 style={{ textDecorationLine: 'underline', }}> Opportunity by Product Groups</h5>
                            <BootstrapTable search height='298' data={this.props.tvopportunityByCategory} striped hover version="4">
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal', width: '160px' }} thStyle={{ whiteSpace: 'normal', width: '160px' }} dataSort={true} isKey dataField='tier4'>Product Group</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='opportunity'>Purchases</TableHeaderColumn>
                                <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='terminatedVendorName'>Leaving Supplier</TableHeaderColumn>
                                <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="80" dataFormat={this.showProductListIcon} dataField='tier4Id' >Products</TableHeaderColumn>

                            </BootstrapTable>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
    renderSizePerPageDropDown = props => {
        return (
          <div className='btn-group'>
            {
              [ 25, 50, 100 ].map((n, idx) => {
                const isActive = (n === props.currSizePerPage) ? 'active' : null;
                return (
                  <button key={ idx } type='button' className={ `btn btn-info ${isActive}` } onClick={ () => props.changeSizePerPage(n) }>{ n }</button>
                );
              })
            }
          </div>
        );
      }

    render() {
        const { selectedVendorPartner } = this.state;

        const { opportunityByMember, opportunityByCategory } = this.props;
        //filtering member table 
        this.filteredOpportunityByMemberArr = _cloneDeep(opportunityByMember);
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        if (!_isEmpty(selectedVendorPartner)) {
            let filteredData = [];
            filteredData = _filter(this.filteredOpportunityByMemberArr, { 'terminatedVendorPartner': selectedVendorPartner });
            this.filteredOpportunityByMemberArr = filteredData;
            console.log('filtered --- ', this.filteredOpportunityByMemberArr);
        }
        //filtering category table 
        this.filteredOpportunityByCategoryArr = _cloneDeep(opportunityByCategory);

        if (!_isEmpty(selectedVendorPartner)) {
            let filteredData = [];
            filteredData = _filter(this.filteredOpportunityByCategoryArr, { 'terminatedVendorPartner': selectedVendorPartner });
            this.filteredOpportunityByCategoryArr = filteredData;
            console.log('filtered --- ', this.filteredOpportunityByCategoryArr);
        }
        //charts
        //for top 10 members
        const { top10Members, top10Categories } = this.props;
        let jsonArr = [];
        let jsonArrName = [];
        if (!_isEmpty(top10Members)) {
        this.props.top10Members.chartData1.map((data, index) => {
            let jsonObj = {};
            console.log('data-----', data);
            jsonObj["Purchases"] = data;
            jsonObj.label = this.props.top10Members.chartData1Member[index];
            jsonObj.memberName = this.props.top10Members.chartData1MemberName[index];
            jsonArr.push(jsonObj);
        });
        
    }
        else {
            jsonArr.push([]);
          }
        jsonArr.shift();
        console.log('xyz ', jsonArr);
        let dataForChart1 = {
            data: {
                columns: [
                    this.props.top10Members.chartData1
                ],
                json: jsonArr,
                keys: {
                    x: 'label',
                    value: ["Purchases"]
                },
                type: 'bar',
                colors: {
                    "Purchases": '#1f77b4'
                },

            },
            legend: {
                position: 'inset',
                show: false,
                inset: {
                    anchor: 'top-left',
                    x: 28,
                    y: -40,
                    step: 1
                }
            },
            tooltip: {
                format: {
                    title: d => this.props.top10Members.chartData1MemberName[d + 1],
                    value: (value, ratio, id) => accounting.formatMoney(value)
                }
            },
            padding: {
                bottom: 100,
            },

            bar: {
                width: {
                    ratio: 0.5 // this makes bar width 50% of length between ticks
                },
                // or
                //width: 100 // this makes bar width 100px
            }, axis: {
                x: {
                    label: { text: 'Member Ids', position: 'inner-right' },
                    type: 'category', // this needed to load string x value,
                    tick: {
                        rotate: -23,
                        multiline: false,
                    },
                    height: 80
                },
                y: {
                    label: { text: 'Purchase Amount', position: 'outer-middle' },
                    type: 'categoryId',
                    tick: {
                        rotate: -20,
                        multiline: false,
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            }
        }
        //for top 10 categories
        let jsonCategoryarr = [];
        if (!_isEmpty(top10Categories)) {
        this.props.top10Categories.chartData2.map((data, index) => {
            let jsonObj = {};
            console.log('data-----', data);
            jsonObj["Purchases"] = data;
            jsonObj.label = this.props.top10Categories.productGroupIdValue[index];
            jsonObj.productGroupName = this.props.top10Categories.chartData2Category[index];
            jsonCategoryarr.push(jsonObj);
        });
    }
    else {
        jsonCategoryarr.push([]);
    }
        jsonCategoryarr.shift();
        //  console.log(jsonCategoryarr);

        let dataForChart2 = {
            data: {
                columns: [
                    this.props.top10Categories.chartData2
                ],
                json: jsonCategoryarr,
                keys: {
                    //   x: 'label',
                    value: ["Purchases"],

                },
                type: 'bar',
                colors: {
                    "Purchases": '#1f77b4'
                },
            },
            legend: {
                position: 'inset',
                show: false,
                inset: {
                    anchor: 'top-left',
                    x: 20,
                    y: -40,
                    step: 1
                }
            },
            tooltip: {
                format: {
                    title: d => this.props.top10Categories.chartData2Category[d + 1],
                    value: (value, ratio, id) => accounting.formatMoney(value)
                }
            },
            padding: {
                bottom: 100,
            },

            bar: {
                width: {
                    ratio: 0.5 // this makes bar width 50% of length between ticks
                },
                // or
                //width: 100 // this makes bar width 100px
            },
            axis: {
                x: {
                    label: { text: 'Rank', position: 'inner-right' },
                    type: 'category', // this needed to load string x value,
                    tick: {
                        rotate: -20,
                        multiline: false
                    },
                    height: 80
                },


                y: {
                    label: { text: 'Purchase Amount', position: 'outer-middle' },
                    tick: {
                        rotate: -20,
                        multiline: false,
                        format: function (d) { let formatted = accounting.formatMoney(d); return formatted.substring(0, formatted.length - 3) }
                        //                format: function (d) { return "$" + d; }
                    }
                }
            },
        }
       
        const productGroupPagination = {
            sizePerPageDropDown: this.renderSizePerPageDropDown
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        let params = this.state.params;
        params = paramsToJSON(params);
        return (
            <div>
                <ToastContainer style={{zIndex: '9999'}}  />
               <nav className="Filters navbar">
                    <div style={{ marginLeft: "60px" }}>
                        <span className="navbar-brand nav-head">{sessionStorage.getItem('imark-vendorName')}  (Compliant Supplier) </span></div>

                        <ul className="navbar-nav flexRowForFilters2" >
                      
                             {/* <nav className="Filters navbar">
                        <div style={{ marginLeft: "60px" }}>
                            <span className="navbar-brand nav-head">{sessionStorage.getItem('vendorName')} (Conversion Opportunity)</span></div>
                      
                    <div className="exportButtonWrapper">
                     <ul className="navbar-nav flexRowForFilters1" > */}
                        <li className="nav-item">
                        <Dropdown clearable onChange={this.handleChange}
                            placeholder='Select Supplier' search fluid selection
                            options={this.props.vendorNamesList}
                            value={this.props.value} />
                              {/* <Dropdown clearable onChange={(e, value)=>this.handleChange(e, value)} 
              placeholder='Select Leaving Supplier' search fluid selection 
              options={this.props.vendorNamesList} /> */}

                            </li>
                            <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                            <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                        value={this.state.selectedYear}
                                        options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control"  style ={{height:'38px',width:'80px'}} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                    <option value="1" selected={ params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={ params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={ params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={ params.quarter == 4 ? true : false} >QTR4</option>
                                    
                                    </select>

                                </li>
                                :
                                <li>
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true}
                                        value={this.state.selectedItem}
                                        options={this.state.items} />

                                </li>
                            }


                        </ul>
                         {/* <ExcelFile filename="VENDOR OPPORTUNITY"  element={<button className="btn btn-primary" style={{ marginRight: "60px",height:'38px',marginBottom: '7px'}}>Export</button>}>
                            <ExcelSheet data={opportunityByMember} name="Opportunity By Member">
                                {console.log('this.props.opportunityByMember',opportunityByMember)}
                                <ExcelColumn label="MEMBER NAME" value="memberName" />
                                <ExcelColumn label="PURCHASES" value="opportunity" />
                                <ExcelColumn label="LEAVING SUPPLIER" value="terminatedVendorName" />
                            </ExcelSheet>
                             <ExcelSheet data={this.props.tvopportunityByCategory} name="Opportunity By Category">
                            {console.log('this.props.tvopportunityByCategory',this.props.tvopportunityByCategory)}
                                <ExcelColumn label="PRODUCT GROUP" value="tier4" />
                                <ExcelColumn label="PURCHASES" value="opportunity" />
                                <ExcelColumn label="LEAVING SUPPLIER" value="terminatedVendorName" />
                            </ExcelSheet>
                         </ExcelFile>  */}
                        <ExcelFile filename="VENDOR OPPORTUNITY"  element={<button className="btn btn-primary" style={{ height: '38px', marginBottom: '7px'}}>Export</button>}>
                             <ExcelSheet data={opportunityByMember} name="Opportunity By Member">
                            <ExcelColumn label="MEMBER NAME" value="memberName" />
                                    <ExcelColumn label="PURCHASES" value="opportunity" />
                                    <ExcelColumn label="LEAVING SUPPLIER" value="terminatedVendorName" />
                            </ExcelSheet>
                            <ExcelSheet data={this.props.tvopportunityByCategory} name="Opportunity By Category">
                            <ExcelColumn label="PRODUCT GROUP" value="tier4" />
                                    <ExcelColumn label="PURCHASES" value="opportunity" />
                                    <ExcelColumn label="LEAVING SUPPLIER" value="terminatedVendorName" />
                            </ExcelSheet>
                        </ExcelFile>
                    {/* </div> */}
                   {/* </div> */}
                </nav>
                {this.state.isLoading ? matLoader() :
                    <div>

                        <div class="row" style={{ paddingBottom: "12px", paddingTop: "2rem", marginLeft: "60px", marginRight: "60px" }}>
                            <div className="row">
                                <div className="col-6">
                                    <div className="card-deck" >
                                        <div className="card shadow-sm mb-3">
                                            <div className="card-header">getOptions</div>
                                            <div className="card-body">
                                                <div className="chart c3" id="topMemberChart">
                                                    <C3Chart data={dataForChart1.data} axis={dataForChart1.axis} tooltip={dataForChart1.tooltip} />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    {this.renderOpportunityByMember()}
                                </div>

                            </div>


                            <div className="row" style={{ paddingBottom: "12px", paddingTop: "0", marginTop: "30px" }}>
                                <div className="col-6">
                                    {this.renderOpportunityByProductGroup()}
                                </div>
                                <div className="col-6" >
                                    <div className="card shadow-sm mb-3">
                                        <div className="card-header">
                                            Top 10 Product Groups
                        </div>
                                        <div className="card-body">
                                            <div class="chart c3" id="topMemberChart">
                                                <C3Chart data={dataForChart2.data} axis={dataForChart2.axis} tooltip={dataForChart2.tooltip} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                {this.state.showProductListModalPopUp ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "500px" }}>

                            <div className="modal-content" style={{ width: "500px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Product Feedback for {this.state.productName}</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductListModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <ExcelFile element={<button className="btn btn-primary">Export</button>}>
                                        <ExcelSheet data={this.props.getProductDetail} name="PurchaseWithinImark">
                                            {/* <ExcelColumn label="PRODUCT ID" value="productGroupId" /> */}
                                            <ExcelColumn label="PRODUCT NAME" value="productDesc" />
                                            {/* <ExcelColumn label="LEAVING SUPPLIER NAME" value="leavingVendorName" /> */}
                                        </ExcelSheet>
                                    </ExcelFile>


                                    <BootstrapTable search options={productGroupPagination} pagination height='400' data={this.props.getProductDetail} striped hover version="4">
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="90px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='tier4Id'>Product Id</TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="120px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='tier4'>Product Name</TableHeaderColumn>
                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='terminatedVendorName'>Out Supplier Name</TableHeaderColumn>
                                        <TableHeaderColumn dataFormat={this.showProductFeedbackIcon} width="80px" dataField='feedback'>Feedback</TableHeaderColumn>
                                        {/* <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="140px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='favorableVendor'>FV Supplier </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} hidden dataField='productGroupId'> </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="150px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='productGroupName'>Product Group Name </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="150px" thStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='rebateOpportunity'>Rebate Opportunity </TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="130px" thStyle={{ whiteSpace: 'normal' }} dataFormat={PercentFormatter} dataSort={true} dataField='rebatePercent'>Rebate Percent</TableHeaderColumn> */}
                                        {/* <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} width="60px" thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='productGroupName'>Product Group Name </TableHeaderColumn> */}
                                    </BootstrapTable>
                                    <div >

                                        <span className="errorText">{}</span>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" onClick={(e) => { this.closeProductListModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div> : ''
                }
                {this.state.showPopUpForProductFedbackDetails ?
                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                            <div className="modal-content" style={{ width: "700px" }}>

                                <div className="modal-header">
                                    <h5 className="modal-title" >Product Feedback for {this.state.productDesc}</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeProductFeedbackModal() }} >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" >
                                    <div >
                                        <form>
                                            <div className="form-group feedbackToggle">
                                                <label >Is {this.state.productName} wrongly classified as {this.state.productDesc}? </label>
                                                <Checkbox toggle onChange={(e, value) => {
                                                    if (value.checked) {
                                                        this.setState({ disableNewProductCategoryDropdown: false, selectCategoryErrorMessage: '' });
                                                    } else {
                                                        this.setState({ disableNewProductCategoryDropdown: true, selectCategoryErrorMessage: '' });
                                                    }
                                                    this.setState({ feedbackToggleForWrongClassification: value.checked });
                                                }} />
                                            </div>
                                            <div className="form-group feedbackToggle">
                                                <Dropdown
                                                    placeholder='Select new Product Category'
                                                    disabled={this.state.disableNewProductCategoryDropdown}
                                                    fluid
                                                    search
                                                    selection
                                                    value={this.props.value}
                                                    options={this.props.ProductCategoryList}
                                                    onChange={(e, value) => this.handleCategoryClick(e, value)}
                                                />
                                            </div>
                                            <div className="form-group feedbackToggle">
                                                <label>Comments</label>
                                                <textarea ref="comment" rows={2} cols={20} value={this.state.textareaValue}
                                                    onChange={(e, value) => this.handleOnChange(e, value)} />

                                            </div>

                                        </form>
                                        <span className="errorText">{this.state.selectCategoryErrorMessage}</span>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" onClick={(e) => { this.sendProductFeedback() }} className="btn btn-primary">Submit</button>
                                    <button type="button" onClick={(e) => { this.closeProductFeedbackModal() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div> : ''
                }


            </div>

        )
    }
}
function mapStateToProps(state) {
    let chartDatafor1 = _get(state, 'vendor.vendorTop10Members', []);
    let chartData1Arr = [];
    let chartData1ArrMemberId = [];
    let chartData1ArrMemberName = [];
    if (!_isEmpty(chartDatafor1)) {
        let chartData1 = chartDatafor1.map((data, index) => {
            chartData1Arr.push(_get(data, 'opportunity', ''));
            chartData1ArrMemberId.push(_get(data, 'memberId', ''));
            chartData1ArrMemberName.push(_get(data, 'memberName', ''));
        })
    }
    else {
        chartData1Arr.push([]);
        chartData1ArrMemberId.push([]);
        chartData1ArrMemberName.push([]);
      }
    chartData1Arr.unshift("data1");
    chartData1ArrMemberId.unshift("data2");
    chartData1ArrMemberName.unshift("data3");

    let chartDatafor2 = _get(state, 'vendor.vendorTop10Categories', []);
    let chartData2Arr = [];
    let productGroupIdval = [];
    let chartData2CategoryId = [];

    if (!_isEmpty(chartDatafor2)) {

        let chartData2 = chartDatafor2.map((data, index) => {
            console.log('new chart ', data);
            chartData2Arr.push(_get(data, 'opportunity', ''));
            chartData2CategoryId.push(_get(data, 'tier4', ''));
            productGroupIdval.push(_get(data, 'tier4Id', ''));
        })
    }
    else {
        chartData2Arr.push([]);
        chartData2CategoryId.push([]);
        productGroupIdval.push([]);
      }
    chartData2CategoryId.unshift("data2");
    chartData2Arr.unshift("data1");
    productGroupIdval.unshift("data3");
    let vendorNames = [];
    // ;
    let vendorNameprops = _get(state, 'vendor.getMemberVendorNames', []);
    vendorNameprops && vendorNameprops.map((vname, index) => {
        // ;
        let vendorNameObj = {
            key: index,
            text: vname.vendorName,
            value: vname.vendorId,
        }
        vendorNames.push(vendorNameObj)
        // ;
    })
    let ProductCategory = [];
    // ;
    let ProductCategoryprops = _get(state, 'corporate.getProductCategorycorporate', []);
    ProductCategoryprops && ProductCategoryprops.map((vname, index) => {
        //;
        let ProductCategoryObj = {
            key: index,
            text: vname.productCategory,
            value: vname.productCategoryId,
        }
        ProductCategory.push(ProductCategoryObj)
        // ;
    })
    return {
        vendorNamesList: vendorNames,
        ProductCategoryList: ProductCategory,
        opportunityByMember: _get(state, 'vendor.vendorOpportunityByMember', []),
        tvopportunityByCategory: _get(state, 'vendor.vendortvOpportunityByCategory', []),
        getProductDetail: _get(state, 'corporate.getProductDetail', []),
        saveProductFeedbackAPI: _get(state, 'member.saveProductFeedback', []),
        getVendorConverisonMonthsFilter: _get(state, 'vendor.getVendorConverisonMonthsFilter', []),
        top10Categories: {
            chartData2: chartData2Arr,
            chartData2Category: chartData2CategoryId,
            productGroupIdValue: productGroupIdval
        },
        top10Members: {
            chartData1: chartData1Arr,
            chartData1Member: chartData1ArrMemberId,
            chartData1MemberName: chartData1ArrMemberName
        },
        vendorIdForCorporate:  window.sessionStorage.getItem ('imark-vendorId'),

        //vendorIdForCorporate: _get(sessionStorage, 'imark-vendorId', ''),
        tabTracking: _get(state, 'corporate.tabTracking', []),
    }

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVendortvOpportunityByCategoryDataAPI: getVendortvOpportunityByCategoryData,
        getVendorOpportunityByMemberDataAPI: getVendorOpportunityByMemberData,
        getVendorTop10CategoriesDataAPI: getVendorTop10CategoriesData,
        getVendorTop10MembersDataAPI: getVendorTop10MembersData,
        //getTerminatedVPNamesAPI: getTerminatedVPNames
        getMemberVendorNamesAPI: getMemberVendorNames,
        getProductCategorycorporateAPI: getProductCategorycorporate,
        getProductDetailAPI: getProductDetail,
        saveProductFeedbackAPI: saveProductFeedback,
        getVendorConverisonMonthsFilterAPI: getVendorConverisonMonthsFilter,
        tabTrackingAPI:tabTracking,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TVPOpportunities);
